import "./scss/RegistrationForm.scss";
import FormFieldInput from './FormFieldInput.jsx'
import FormFieldCheckbox from './FormFieldCheckbox.jsx'
import FormFieldChoiceOptions from './FormFieldChoiceOptions.jsx'
import FormFieldDate from './FormFieldDate.jsx'
import FormFieldPhone from './FormFieldPhone.jsx'
import FormFieldSignature from './FormFieldSignature.jsx'
import FormFieldNumeric from './FormFieldNumeric.jsx'
import SubmitButton from "./SubmitButton"
function RegistrationForm({ data, value, sending, elementErrors, onChange, onSubmit, autofill, button }) {
	console.log('~RegistrationForm', data.id, value, elementErrors)
	const isAnytimeHack = 
		window.location.pathname.includes("wvImzlzfHT9PycsUBku6") || // debug id
		window.location.pathname.includes("8xZZrRqxJqQHn9we0MPo"); // anytime id

	const setData = (id, newValue) => {
		console.log('* RegistrationForm sets and sends:', data.id, value, '->', { ...value, [id]: newValue })
		onChange(data.id, { ...value, [id]: newValue });
	};
	const getFormStyling = () => {
		return {
			marginTop: data?.marginTop,
			background: data?.background,
			color: data?.textColor,
		};
	}
	const inputDisabled = () => {
		if (sending) return sending;
		let atLeastOneRequiredNotFilled = false;
		data.fields.map((field) => {
			if (field.required) {
				if (!value?.[field.id]) atLeastOneRequiredNotFilled = true;
			}
		})
		return atLeastOneRequiredNotFilled;
	}
	const firstAnytimeCheckboxId = () => {
		if(isAnytimeHack && data.fields){
			console.log("data.fields", data.fields)
			return data.fields.find(function (field) {
				return field.type === "checkbox"
			})?.id;
		}
		else{
			return null;
		}
	}
	
	return (
		<div style={getFormStyling()} className="registration">
			{data.header && <div key="header" dangerouslySetInnerHTML={{ __html: data.header }} />}
			{data.fields && data.fields.map(function (field) {
				switch (field.type) {
					case 'firstName':
					case 'lastName':
					case 'text':
					case 'email':
						return <FormFieldInput autofill={autofill} key={field.id} data={field} value={value?.[field.id]} sending={sending} elementErrors={elementErrors?.[field.id]} onChange={setData} />;
					case 'checkbox':
						if(isAnytimeHack && firstAnytimeCheckboxId() === field.id){
							return (
								<div>
									<p style={{ fontSize: "12px", marginTop: "18px" }}>
										<i>
											Δηλώνω ότι αφού διάβασα τους
											<a href="https://conferiencestorage.s3.amazonaws.com/13871/sharedDocuments/dc02ab17b5d851ee638a7045f046a0e6bf0b87ff.pdf" target="_blank"> όρους Συμμετοχής </a>
											του Ringer Game και ενημερώθηκα για τους σκοπούς που θα επεξεργαστεί η ΑΝΥΤΙΜΕ/ΙΝΤΕΡΑΜΕΡΙΚΑΝ τα προσωπικά μου δεδομένα:
										</i>
									</p>
									<FormFieldCheckbox key={field.id} data={field} value={value?.[field.id]} sending={sending} elementErrors={elementErrors?.[field.id]} onChange={setData} />
								</div>
							)
						}
						else 
							return <FormFieldCheckbox key={field.id} data={field} value={value?.[field.id]} sending={sending} elementErrors={elementErrors?.[field.id]} onChange={setData} />;
					case 'choice':
						return <FormFieldChoiceOptions key={field.id} data={field} value={value?.[field.id]} sending={sending} elementErrors={elementErrors?.[field.id]} onChange={setData} />;
					case 'date':
						return <FormFieldDate key={field.id} data={field} value={value?.[field.id]} sending={sending} elementErrors={elementErrors?.[field.id]} onChange={setData} />;
					case 'tel':
						return <FormFieldPhone key={field.id} data={field} value={value?.[field.id]} sending={sending} elementErrors={elementErrors?.[field.id]} onChange={setData} />;
					case 'signature':
						return <FormFieldSignature key={field.id} data={field} value={value?.[field.id]} sending={sending} elementErrors={elementErrors?.[field.id]} onChange={setData} />;
					case 'ssn':
						return <FormFieldNumeric autofill={autofill} key={field.id} data={field} value={value?.[field.id]} sending={sending} elementErrors={elementErrors?.[field.id]} onChange={setData} />;
					default:
						console.error('Invalid type', field.type);
						return <></>;
				}
			})}
			<SubmitButton
				text={data?.submitText}
				size={button?.submitSize}
				sending={sending}
				disabled={inputDisabled()}
				onSubmit={onSubmit}
				containerStyle={{marginTop:"15px"}}
				buttonStyle={{borderRadius:button?.borderRadius}}
			/>
			{data.footer && <div key="footer" dangerouslySetInnerHTML={{ __html: data.footer }} />}
		</div>
	);
};
export default RegistrationForm;
